import { NavigateFunction } from "react-router-dom";
import { ROUTE_PATHS } from "../../../../../routes/paths";
import { MoreAboutAmbassadorCompanyFormData } from "./config";

export function handleMoreAboutAmbassadorCompanySuccess(
  navigate: NavigateFunction
): void {
  navigate(ROUTE_PATHS.SIGNUP_SUCCESS);
}

export function getCreateProfilePayload(
  data: MoreAboutAmbassadorCompanyFormData
): {
  company: string;
  title?: string;
  linkedIn?: string;
} {
  return {
    company: data.company,
    ...(data.title && { title: data.title }),
    ...(data.linkedIn && { linkedIn: data.linkedIn }),
  };
}
